// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__60N1p","load":"Loader_load__HahPF"};